import { Button, Form, Header, Icon, Progress, Segment } from "semantic-ui-react";
import { useAgeReadyContext } from "../../../AgeReadyContext/AgeReadyContext";
import { trackPromise } from "react-promise-tracker";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import styles from "./Documents.module.css"
import Dropzone from "react-dropzone";


interface FileUploadProps {
    label: string;
    caregiverId: string;
    recipientId: string;
    recipientName: string;
    domain: string;
    task: string;
    id: string;
    isUploading: boolean;
    setIsUploading: (uploading: boolean) => void;
    refreshDocTableData: () => void;
    fieldProps?: {};
    inputProps?: {};
  }

const FileUpload: React.FC<FileUploadProps>  = (props) => {
  const { caregiverId, recipientId, recipientName, domain, task, fieldProps, inputProps, isUploading,
    setIsUploading, refreshDocTableData } = props;

  const { documentInfoStore } = useAgeReadyContext();
  const [uploadProgress, setUploadProgress] = useState<number>(0);


  const _onDrop = async (e: any ) => {
    setUploadProgress(0);
    setIsUploading(true);



    await fileChange(e);

    return () => {
        setUploadProgress(0);
    };
  };

  const onProgress = (progressEvent:ProgressEvent) => {
    if (progressEvent.lengthComputable) {
      const percentComplete = Math.round((progressEvent.loaded / progressEvent.total) * 100);
      if(percentComplete)
      setUploadProgress(percentComplete)
    }
  };

  const fileChange = async (e: any) => {
    documentInfoStore.setUploadMessage("");
    const selectedFile = e[0];
    const encodedDocumentString = await trackPromise(toBase64Async(selectedFile));
    if (!!encodedDocumentString) {
      await trackPromise(documentInfoStore.uploadDocument((encodedDocumentString as string), caregiverId, recipientId, recipientName, domain, task, selectedFile,onProgress));    
      if (!documentInfoStore.uploadMessage.includes('Error:')) {
        refreshDocTableData();
        setUploadProgress(100);
      }
    }
  };

  const toBase64Async = (file: File) => new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => resolve(fileReader.result);
    fileReader.onerror = error => reject(error);
  });
  
  const renderButtonToBrowse = () => {
    return (
      <>
        <Button primary as="label" htmlFor="file" type="button" content="Click to Browse" id={styles['browse-click']} disabled={documentInfoStore.isLoading} style={{marginTop: '6px'}} />
      </>
    )
  }

  return (
    <Form.Field {...fieldProps}>
        <Dropzone
        {...inputProps}
        multiple={false}
        onDrop={acceptedFiles => _onDrop(acceptedFiles)}
        >
        {({ isDragActive, acceptedFiles, getRootProps, getInputProps }) => {            
            const file =  [...acceptedFiles].pop();
            const hasFile = !!file && !isUploading;
            const dndColor = hasFile ? "green"
                            : !!documentInfoStore.uploadMessage ? "red"
                                : isDragActive || isUploading 
                                    ? "blue"
                                    : "grey";

            const showProgress = !!uploadProgress && (hasFile || isUploading);

            return (
            <Segment className={styles.docDropZoneSeg}>
                <div {...getRootProps()} >
               {!isUploading && <input {...getInputProps()} />}
                    {showProgress && (
                    <Progress
                        percent={uploadProgress}
                        attached="top"
                        autoSuccess
                        color={dndColor}
                    />
                    )}
                    <Header icon textAlign="center" size="small" color={dndColor} >
                        <Icon name="cloud upload" color={dndColor} />
                        <Header.Content>
                            {file && (hasFile || isUploading) 
                            ? (
                                <>
                                    {file.name} - {file.size} bytes
                                    <Header.Subheader>
                                    {isUploading ? `Uploading.. ${uploadProgress}%` : "Uploaded"}.
                                    </Header.Subheader>
                                    {!isUploading && renderButtonToBrowse()}
                                </>
                            ) : (
                                <>
                                    Drag Files Here
                                    <Header.Subheader content="Or" />
                                    {renderButtonToBrowse()}
                                </>
                            )}
                        </Header.Content>
                    </Header> 
                </div>
            </Segment>
            );
        }}
        </Dropzone>
    </Form.Field>
  );
}

export default observer(FileUpload);